export const ROUTES = {
  ROOT: '/',
  WAITING_FOR_OPERATOR: '/WAITING_FOR_OPERATOR',
  LOGIN: '/LOGIN',

  CHAT: '/CHAT',
  CHAT_END: '/CHAT/RATE',

  THANK_YOU: '/THANK_YOU',
  OPERATOR_INFO: '/OPERATOR_INFO',
  OPERATOR_FEEDBACK: '/OPERATOR_FEEDBACK',

  INQUIRY: '/INQUIRY'
};
